var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 45,
  height: 31.5,
  viewBox: "0 0 45 31.5"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-cloud-upload-alt",
  "data-name": "Icon awesome-cloud-upload-alt",
  d: "M37.8,15.933A6.758,6.758,0,0,0,31.5,6.75a6.716,6.716,0,0,0-3.748,1.139,11.251,11.251,0,0,0-21,5.611c0,.19.007.38.014.57a10.128,10.128,0,0,0,3.361,19.68H36a9,9,0,0,0,1.8-17.817ZM27.661,20.25h-4.6v7.875a1.128,1.128,0,0,1-1.125,1.125H18.563a1.128,1.128,0,0,1-1.125-1.125V20.25h-4.6a1.123,1.123,0,0,1-.795-1.92l7.411-7.411a1.129,1.129,0,0,1,1.589,0l7.411,7.411a1.124,1.124,0,0,1-.795,1.92Z",
  transform: "translate(0 -2.25)",
  fill: "currentColor"
})));
export { SvgUpload as ReactComponent };
export default __webpack_public_path__ + "static/media/upload.890247b3f70277c980e31bdad580e494.svg";